import axios from 'axios'
import { i18n } from '../../../plugins/i18n'
import { castAttributesForCamelCase } from '../../../modules/string_converter'

export const companiesLocationStores = {
  namespaced: true,
  state: {
    data: [],
    meta: {allStoreIds: []},
    loading: false,
    loadError: false,
    filteredCount: 0,
    filteredStores: [],
  },
  mutations: {
    initStoresState(state) {
      state.data = []
      state.meta = null
    },
    readStores(state) {
      state.loading = true
      state.loadError = false
    },
    readStoresSuccess(state, payload) {
      state.data = payload.data.map(v => {
        if (v.attributes.regular_hours) {
          // 段階的にcamelCaseにしていく
          v.attributes.regularHours = v.attributes.regular_hours.map(hour => castAttributesForCamelCase(hour))
          delete v.attributes.regular_hours
        }
        return v
      })
      const meta = payload.meta
      meta.allStoreIds = meta.all_store_ids.map(id => Number(id))
      delete meta.all_store_ids
      state.meta = meta
      state.loading = false
      state.loadError = false
    },
    readStoresFailure(state) {
      state.loading = false
      state.loadError = true
    },
    deleteStore(state) {
      state.data = []
      state.meta = null
      state.loading = false
      state.loadError = false
    },
    setValuesForFilter(state, payload) {
      state.filteredCount = payload.meta.filtered_store_count
      state.filteredStores = payload.data
    },
  },
  actions: {
    initStoresState({ commit }) {
      commit('initStoresState')
    },
    readStores({ commit }, payload) {
      const { companyUuid, params } = payload
      commit('readStores')
      return axios
        .post(`/api/companies/${ companyUuid }/location/stores/search.json`, params)
        .then(res => {
          commit('readStoresSuccess', res.data)
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('readStoresFailure', err)
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readStoresForFilter({ commit }, payload) {
      const { companyUuid, params } = payload
      return axios
        .post(`/api/companies/${ companyUuid }/location/stores/search.json`, params)
        .then(res => {
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    deleteStore({ commit }, { companyUuid, uuid }) {
      return axios
        .delete('/api/companies/' + companyUuid + '/location/stores/' + uuid)
        .then(() => {
          commit('deleteStore')
          alert(i18n.t('messages.deletedDelay', { value: i18n.t('models.store.modelName') }))
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.message }, { root: true })
        })
    },
    async readStoresWithMask({ commit }, payload) {
      const { companyUuid, readMask, params } = payload
      commit('readStores')

      try {
        const res = await axios.post(
          `/api/companies/${ companyUuid }/location/stores/search.json`,
          params,
          {
            params: {
              read_mask: readMask,
            },
          },
        )
        commit('readStoresSuccess', res.data)
        commit('setValuesForFilter', res.data)
      } catch (error) {
        commit('readStoresFailure', error)
        commit('flash/updateFlash', { type: 'alert', message: error.response.data.message }, { root: true })
      }
    },
  }
}
